@if (isArrow) {
<div class="popover-arrow"></div>
}

<ng-template ad-host></ng-template>
